/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/
import { useQuery, gql } from '@apollo/client';
import { useSessionContext } from '@exo/frontend-common-session-context';

export const useOpenPooledDasAccounts = (transactionType) => {
  const session = useSessionContext()
  const variables = {
      "transactionType": transactionType
  };

    const OPEN_POOLED_DAS_ACCOUNT_GQL = gql`
    query OpenPooledDasAccounts($transactionType: String!) {
    openPooledDasAccounts(transactionType: $transactionType) {
    dasAccounts {
      eligibleFundsSourceResult {
        agreementShortName
        altkey {
          accountNoKey
          accountNum
          bankNum
          branchNum
        }
        englishDesc
        englishTxt
        frenchDesc
        frenchTxt
        currentBalanceCcyamt {
          amount
        }
      }
    }
  }
}
    `;

    const { data, loading, error,refetch} = useQuery(OPEN_POOLED_DAS_ACCOUNT_GQL, {
      variables,
      fetchPolicy: "network-only",
      skip : session.type !== "TD_BANK_USER"
    });

    if (error && error.graphQLErrors && error.graphQLErrors[0]) {
      error.graphQLErrors[0].handled = true;
      console.log('First error has been handled:', error.graphQLErrors[0]);
    }

    return {accountKeyData: data, loading, error,refetch};
}
